import React from 'react';
import Wave from '@/components/elements/wave';
import Image from '@/components/elements/image';

export default function LibraryHeader({ title, subtitle, icon }) {
	return (
		<div>
			<div className="prose">
				<div className="bg-sky-lightest h-44">
					<div className="container pt-9">
						<div className="flex align-center justify-center">
							{icon && <Image appearance="w-14 h-14 m-0 mr-6" src={icon.filename} alt={icon.alt || ''} />}
							<h1 className="text-5xl text-center pb-4">{title}</h1>
						</div>
						<div className="text-center text-xl">{subtitle}</div>
					</div>
				</div>
			</div>
			<Wave backgroundColor="SKY_LIGHTEST" />
		</div>
	);
}
